var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33318 14.0026H6.66652M11.9998 5.33594C11.9998 4.27507 11.5784 3.25766 10.8283 2.50751C10.0781 1.75736 9.06072 1.33594 7.99985 1.33594C6.93898 1.33594 5.92157 1.75736 5.17142 2.50751C4.42128 3.25766 3.99985 4.27507 3.99985 5.33594C3.99985 7.39606 3.48016 8.80658 2.89963 9.73955C2.40993 10.5265 2.16509 10.92 2.17407 11.0298C2.18401 11.1513 2.20976 11.1977 2.3077 11.2703C2.39616 11.3359 2.79491 11.3359 3.59242 11.3359H12.4073C13.2048 11.3359 13.6035 11.3359 13.692 11.2703C13.7899 11.1977 13.8157 11.1513 13.8256 11.0298C13.8346 10.92 13.5898 10.5265 13.1001 9.73955C12.5195 8.80658 11.9998 7.39606 11.9998 5.33594Z",
    stroke: "#EBEBF5",
    strokeOpacity: 0.64,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f97f183438315b9b8dd7e85a8da1727a.svg";
export { ForwardRef as ReactComponent };